import IsSearchingComponent from "./IsSearchingComponent";

export default IsSearchingComponent;